const subclipPreviewMixin = {
    data(){
        return {
            videoFrameCallbackID:null,
        }
    },
    methods:{
        getMarkerValue(time){
            let reg = new RegExp(':');
            if(reg.test(time)){
                return this.hhmmssToMs(time);
             }
             return time / 1000;
        },
        videoFrameCallback(){
            console.log('[videoFrameCallback] videoFrameCallback........time:',this.controller.player.currentTime());
            /* Not working because player will in the stop state initially then user will play manually
            try{
                if(this.controller.player && this.controller.player.paused()){
                      return;
                }
            }catch(e){console.log(e)}
            */
            if(this.controller.player.currentTime() >=  this.currentMarkoutValue){
               this.controller.player.pause();
            }else{
                this.controller.player.requestAnimationFrame(this.videoFrameCallback);
            }
        },
        addMarkersToTimeline(markersList){
           this.removeSubclipMarker();
           let totalPlayerDuration = this.controller.player.duration();
           let progressBar = this.controller.player.controlBar.progressControl.children_[0].el_;
            for(let i=0;i<markersList.length;i++){
                let left =( markersList[i].time/ totalPlayerDuration * 100)+'%';
                let time = markersList[i].time;
                if(time > totalPlayerDuration) continue;
                let markerDiv = document.createElement('div');
                markerDiv.classList.add('vjs-sub-clip-marker');
                markerDiv.style.cssText += `left:${left}`;
                markerDiv.setAttribute('data-time',time);
                progressBar.appendChild(markerDiv);
            }
        },
        addLineBetweenMarkers(){
            try{
                [].map.call(this.$el.querySelectorAll('.subclip-timeline-marker'),(el)=>{
                    el.remove();
                })
            }catch(e){console.log(e)}
            let progressBar = this.controller.player.controlBar.progressControl.children_[0].el_;
            let div = document.createElement('div');
            div.classList.add('subclip-timeline-marker');
            let addedMarkersEl = Array.from(this.$el.querySelectorAll('.vjs-sub-clip-marker')) || Array.from(parent.document.querySelectorAll('.vjs-sub-clip-marker'));
            let width = addedMarkersEl[1].getBoundingClientRect().left - addedMarkersEl[0].getBoundingClientRect().left;
            div.style.cssText = `width:${width}px;top: -2.1px;height: 8px;border-radius: 5px; background: #e91e63; position: absolute; left:calc(${addedMarkersEl[0].style.left} - 1.7px);`
            progressBar.appendChild(div);
        },

        removeSubclipMarker(){
            try{
                [].map.call(this.$el.querySelectorAll('.vjs-sub-clip-marker'),(el)=>{
                    el.classList.remove('vjs-sub-clip-marker');
                })
            }catch(e){console.log(e)}
            
        },

        removeTimeLineMarkers(){
            try{
                [].map.call(this.$el.querySelectorAll('.sub-clip-markin-markout-play'),(el)=>{
                    el.classList.remove('sub-clip-markin-markout-play');
                })
            }catch(e){console.log(e)}
            try{
                [].map.call(this.$el.querySelectorAll('.vjs-sub-clip-marker'),(el)=>{
                    el.remove();
                })
            }catch(e){console.log(e)}

            try{
                [].map.call(this.$el.querySelectorAll('.subclip-timeline-marker'),(el)=>{
                    el.remove();
                })
            }catch(e){console.log(e)}
        },

    }
};

export default subclipPreviewMixin;